import type { Address } from "@opensea/utils"
import { initGraphQLTada } from "gql.tada"
import type { JSONResolver } from "graphql-scalars"
import type { introspection } from "./gen/graphql-env"

export const graphql = initGraphQLTada<{
  introspection: typeof introspection
  scalars: {
    DateTime: string
    JSON: typeof JSONResolver
    Address: Address
    BigDecimal: string
    BigInteger: number
    ChainIdentifier: string
    UUID: string
    MarketplaceIdentifier: string
    SwapProtocolIdentifier: string
  }
}>()
